var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPartyPickupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13",
    "data-name": "Group 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.5,
    height: 94.745,
    viewBox: "0 0 67.5 94.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_512",
    "data-name": "Rectangle 512",
    width: 67.5,
    height: 94.745,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M66.187,23.46H55.154a21.145,21.145,0,1,0-42.032,0H1.313A1.313,1.313,0,0,0,0,24.773v68.66a1.313,1.313,0,0,0,1.313,1.313H66.187A1.313,1.313,0,0,0,67.5,93.433V24.773a1.313,1.313,0,0,0-1.313-1.313M15.618,21.145a18.52,18.52,0,1,1,36.89,2.315H15.768a18.578,18.578,0,0,1-.15-2.315",
    fill: "#0678ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M120.091,413.12v2.363h-1.849v-7.13h2.95a2.456,2.456,0,0,1,1.807.641,2.21,2.21,0,0,1,.663,1.732,2.318,2.318,0,0,1-.631,1.775,2.374,2.374,0,0,1-1.775.62Zm0-1.5h.62a1.208,1.208,0,0,0,.78-.224.816.816,0,0,0,.235-.652.866.866,0,0,0-.214-.641,1.087,1.087,0,0,0-.791-.257h-.631Z",
    transform: "translate(-106.357 -367.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M170.169,414.285h-2.587l-.481,1.2h-1.956l2.737-7.13h2.02l2.683,7.13h-1.978Zm-.492-1.411-.8-2.309-.78,2.309Z",
    transform: "translate(-148.546 -367.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M248.117,408.352a2.3,2.3,0,0,1,1.742.631,2.347,2.347,0,0,1,.609,1.6,2.057,2.057,0,0,1-.567,1.486,2,2,0,0,1-.984.492l2.234,2.918h-2.3l-1.775-2.737v2.737h-1.849v-7.13Zm-1.037,3.2h.353a1.389,1.389,0,0,0,.9-.289.887.887,0,0,0,.235-.6.841.841,0,0,0-.246-.6,1.255,1.255,0,0,0-.887-.278h-.353Z",
    transform: "translate(-220.583 -367.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M303.8,409.923v5.559h-1.849v-5.559H300.43v-1.572h4.885v1.572Z",
    transform: "translate(-270.233 -367.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M351.61,412.062l-2.576-3.709h2.213l1.347,1.946,1.293-1.946h2.245l-2.662,3.709v3.421h-1.86Z",
    transform: "translate(-313.952 -367.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M195.516,328.509l1.1-6.483h1.662l1.312,3.46,1.39-3.46h1.681l.972,6.483H201.95l-.476-3.732-1.565,3.732h-.671l-1.5-3.732-.554,3.732Z",
    transform: "translate(-175.864 -289.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M275.7,325.4l-2.342-3.373h2.012L276.6,323.8l1.176-1.769h2.041l-2.42,3.373v3.11H275.7Z",
    transform: "translate(-245.885 -289.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M122.138,521.375v4.977h-3.9V511.33h6.216a5.173,5.173,0,0,1,3.806,1.351,4.655,4.655,0,0,1,1.4,3.648,4.883,4.883,0,0,1-1.329,3.739,5,5,0,0,1-3.739,1.306Zm0-3.153h1.306a2.543,2.543,0,0,0,1.644-.473,1.719,1.719,0,0,0,.5-1.374,1.823,1.823,0,0,0-.45-1.351,2.289,2.289,0,0,0-1.667-.541h-1.329Z",
    transform: "translate(-106.357 -459.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_511",
    "data-name": "Rectangle 511",
    width: 3.896,
    height: 15.022,
    transform: "translate(24.924 51.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M318.367,523.73a9.275,9.275,0,0,1-3.378.743,8.17,8.17,0,0,1-5.811-2.252,7.881,7.881,0,0,1-2.275-5.473,7.882,7.882,0,0,1,7.95-7.883,9.307,9.307,0,0,1,3.513.766v4.662a4.183,4.183,0,0,0-3.4-1.644,3.8,3.8,0,0,0-2.7.991,4.2,4.2,0,0,0-1.306,3.086,4.145,4.145,0,0,0,1.216,2.928,4.2,4.2,0,0,0,2.793,1.036,4.409,4.409,0,0,0,3.4-1.576Z",
    transform: "translate(-276.056 -457.719)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M445.014,517.523l4.775-6.193h4.82l-5.968,7.117,6.509,7.905H450.1l-5.09-6.509v6.509h-3.9V511.33h3.9Z",
    transform: "translate(-396.781 -459.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M216.356,693.719v8.9a3.038,3.038,0,0,0,.766,2.32,2.767,2.767,0,0,0,3.648.068,3.289,3.289,0,0,0,.878-2.725v-8.558h3.9v8.626a6.1,6.1,0,0,1-1.689,4.865,6.487,6.487,0,0,1-4.955,1.869,6.707,6.707,0,0,1-4.977-1.8,7.008,7.008,0,0,1-1.464-4.932v-8.626Z",
    transform: "translate(-191.105 -623.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M373.423,708.749v-4.986h2.455a5,5,0,0,0,3.739-1.306,4.882,4.882,0,0,0,1.329-3.739,4.655,4.655,0,0,0-1.4-3.648,5.174,5.174,0,0,0-3.806-1.351h-6.216v15.106m6.847-8.688a2.543,2.543,0,0,1-1.644.473h-1.306v-3.739h1.329a2.289,2.289,0,0,1,1.667.541,1.823,1.823,0,0,1,.45,1.351,1.719,1.719,0,0,1-.5,1.374",
    transform: "translate(-332.386 -623.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M425.279,343.4V328.783a.126.126,0,0,1,.125-.121h1.789a.122.122,0,0,0,.087-.207l-3.9-4.006a.122.122,0,0,0-.173,0l-4,4.009a.122.122,0,0,0,.086.208h1.964a.115.115,0,0,1,.117.121l.009,14.688",
    transform: "translate(-377.04 -291.805)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPartyPickupIcon);
export default __webpack_public_path__ + "static/media/MyPartyPickupIcon.fa3475c9182438fbfef116a8b0cb111d.svg";
export { ForwardRef as ReactComponent };